<template>
  <v-container>
    <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
    <v-row>
      <v-col>
        <span class="text-tcdc-green header bold">FAQS</span>
      </v-col>
    </v-row>
    <v-tabs v-model="tab" color="#2e8037">
      <v-tab v-for="(item, index) in tabs" :key="index.toString()">
        <span class="sub-header1 bold">{{item.category}}</span>
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item v-for="(item, index) in tabs" :key="index.toString()">
        <v-row>
          <v-col>
            <FaqsExpandable :items="faqs.filter(q => q.category_id === item.id)" />
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import FaqsExpandable from "../../components/expandables/FaqsExpandable";
import { mapState } from 'vuex';

export default {
  components: {
    FaqsExpandable
  },
  async created() {
    this.items[0].text = this.branchName;
    if (!this.faqs) {
      await this.$store.dispatch('Faq/onGetAllFaqs', this.lang);
    }
    let exist = [];
    for (const item of this.faqs) {
      if (!exist.includes(item.category_id)) {
        exist.push(item.category_id);
        this.tabs.push({ id: item.category_id, category: item.category_name });
      }
    }
  },
  computed: {
    ...mapState({
      branchName: state => state.Branch.branch_name,
      lang: state => state.Branch.lang,
      faqs: state => state.Faq.faqs
    }),
    branchChanged: function () {
      return this.branchName;
    }
  },
  watch: {
    branchChanged: function() {
      this.items[0].text = this.branchChanged;
    }
  },
  data: () => ({
    tab: "1", // initial
    tabs: [
      // { name: "about member", value: "1" },
      // { name: "about library", value: "2" }
    ],
    items: [
      {
        text: 'TCDC BANGKOK',
        to: "/home"
      },
      {
        text: "PROGRAM",
        to: "/home"
      }
    ],
    list: [
      {
        title: "ABOUT MEMBER",
        faqList: [
          {
            id: 1,
            title: "ตอนนี้อัตราค่าสมัครเหมือนเดิมหรือไม่",
            content:
              "TCDC membership rate is not changed, please see in the link  https://web.tcdc.or.th/th/member"
          },
          {
            id: 2,
            title: "สมาชิกสามารถพาบุคคลอื่นเข้าห้องสมุดได้หรือไม่",
            content:
              "Only TCDC's 5th Anniversary members are allowed to bring another with into the library, please contact the staff at Info Guru Counter."
          },
          {
            id: 3,
            title: "สมัครสมาชิกต้องใช้หลักฐานอะไรบ้าง",
            content:
              "หากสมัครในประเภทนักเรียน/นักศึกษา ต้องแสดงบัตรประจำตัวนักเรียน/นักศึกษา ถ้าสมัครในประเภทเจ้าหน้าที่รัฐ/ครู/อาจารย์และผู้สูงอายุ ต้องแสดงบัตรข้าราชการหรือบัตรพนักงานของรัฐ ส่วนผู้สูงอายุต้องแสดงบัตรประจำตัวประชาชน และหากสมัครสมาชิกในประเภทปกติให้แสดงบัตรประจำตัวประชาชน"
          },
          {
            id: 4,
            title:
              "หากต้องการออกใบเสร็จเพื่อนำไปเบิกกับทางบริษัทสามารถทำได้หรือไม่",
            content:
              "หากต้องการออกใบเสร็จในนามบริษัทสามารถแจ้งเจ้าหน้าที่เคาน์เตอร์ Info Guru ตอนชำระเงิน โดยแจ้งที่อยู่บริษัทให้กับเจ้าหน้าที่ทราบ"
          },
          {
            id: 5,
            title:
              "ในกรณีเป็นชาวต่างชาติที่ทำงานในประเทศไทยสามารถสมัครในแบบประชาชนทั่วไปได้หรือไม่",
            content:
              "Foreigners working in Thailand can apply for the membership. For a daily membership, passport can be submitted at the Info Guru counter. In case of applying for yearly membership, fill out the information on my.tcdc.or.th and make a payment at the Info Guru counter."
          },
          {
            id: 6,
            title: "หากไม่ได้นำบัตรสมาชิกมาสามารถเข้าใช้บริการได้หรือไม่",
            content:
              "You can access library through QR Code by logging in to the website my.tcdc.or.th. or contact the staff at the Info Guru counter."
          },
          {
            id: 7,
            title: "ปัจจุบันมีสมาชิกกี่คน",
            content: "ประมาณ 9000 คน"
          },
          {
            id: 7,
            title: "สามารถให้ผู้อื่นนำบัตรมาใช้ได้หรือไม่",
            content: "เจ้าของบัตรเท่านั้นที่สามารถเข้าใช้บริการของห้องสมุดได้"
          }
        ]
      },
      {
        title: "ABOUT LIBRARY",
        faqList: [
          {
            id: 1,
            title: "ตอนนี้อัตราค่าสมัครเหมือนเดิมหรือไม่",
            content:
              "TCDC membership rate is not changed, please see in the link  https://web.tcdc.or.th/th/member"
          },
          {
            id: 2,
            title: "สมาชิกสามารถพาบุคคลอื่นเข้าห้องสมุดได้หรือไม่",
            content:
              "Only TCDC's 5th Anniversary members are allowed to bring another with into the library, please contact the staff at Info Guru Counter."
          },
          {
            id: 3,
            title: "สมัครสมาชิกต้องใช้หลักฐานอะไรบ้าง",
            content:
              "หากสมัครในประเภทนักเรียน/นักศึกษา ต้องแสดงบัตรประจำตัวนักเรียน/นักศึกษา ถ้าสมัครในประเภทเจ้าหน้าที่รัฐ/ครู/อาจารย์และผู้สูงอายุ ต้องแสดงบัตรข้าราชการหรือบัตรพนักงานของรัฐ ส่วนผู้สูงอายุต้องแสดงบัตรประจำตัวประชาชน และหากสมัครสมาชิกในประเภทปกติให้แสดงบัตรประจำตัวประชาชน"
          },
          {
            id: 4,
            title:
              "หากต้องการออกใบเสร็จเพื่อนำไปเบิกกับทางบริษัทสามารถทำได้หรือไม่",
            content:
              "หากต้องการออกใบเสร็จในนามบริษัทสามารถแจ้งเจ้าหน้าที่เคาน์เตอร์ Info Guru ตอนชำระเงิน โดยแจ้งที่อยู่บริษัทให้กับเจ้าหน้าที่ทราบ"
          },
          {
            id: 5,
            title:
              "ในกรณีเป็นชาวต่างชาติที่ทำงานในประเทศไทยสามารถสมัครในแบบประชาชนทั่วไปได้หรือไม่",
            content:
              "Foreigners working in Thailand can apply for the membership. For a daily membership, passport can be submitted at the Info Guru counter. In case of applying for yearly membership, fill out the information on my.tcdc.or.th and make a payment at the Info Guru counter."
          },
          {
            id: 6,
            title: "หากไม่ได้นำบัตรสมาชิกมาสามารถเข้าใช้บริการได้หรือไม่",
            content:
              "You can access library through QR Code by logging in to the website my.tcdc.or.th. or contact the staff at the Info Guru counter."
          },
          {
            id: 7,
            title: "ปัจจุบันมีสมาชิกกี่คน",
            content: "ประมาณ 9000 คน"
          },
          {
            id: 7,
            title: "สามารถให้ผู้อื่นนำบัตรมาใช้ได้หรือไม่",
            content: "เจ้าของบัตรเท่านั้นที่สามารถเข้าใช้บริการของห้องสมุดได้"
          }
        ]
      }
    ]
  })
};
</script>

<style>
</style>
